import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from "react-router-dom";

import styles from './profile.css';

import WorkNav from '../../components/WorkNav/WorkNav';
import Summary from '../../components/Summary/Summary';

import DataStore from '../../stores/DataStore.js';

class Profile extends Component {

	constructor(props) {
    super(props);

    this.data = this.props.data;
    this.navigate = this.navigate.bind(this);
  }

  navigate(event) {
    if (event.target.className === 'about-link') {
      event.preventDefault();
      let link = event.target.getAttribute('href');
      this.props.history.push(link);
    }
  }

	render() {
    const { content } = this.data;

    return (
	    <div className={styles.wrapper}>
        <div className={styles.content}><Summary onClick={event => this.navigate(event)} data={content.rendered} />

          <WorkNav data={this.data} />
        </div>
      </div>
		);
	}
}

export default withRouter(Profile);



// WEBPACK FOOTER //
// ./src/components/Profile/Profile.js